import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowSelectEvent,
} from 'primeng/table';
import { OpkraevningUdestaaendeService } from '../opkraevning-udestaaende.service';

@Component({
  selector: 'app-opkraevning-udestaaende-result',
  imports: [
    DatePipe,
    DecimalPipe,
    TableModule,
    TableRowDirective,
    KeepScrollPositionDirective,
  ],
  templateUrl: './opkraevning-udestaaende-result.component.html',
  styleUrl: './opkraevning-udestaaende-result.component.css',
})
export class OpkraevningUdestaaendeResultComponent {
  opkraevningUdestaaendeService = inject(OpkraevningUdestaaendeService);
  data = this.opkraevningUdestaaendeService.datasource.data;
  tableData = computed(() => this.data()?.data || []);

  onRowSelect(e: TableRowSelectEvent) {
    this.opkraevningUdestaaendeService.selectUdestaaendeResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.opkraevningUdestaaendeService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
